import React from "react";
import { useI18n } from "../../i18n";

/**
 * Catalog search. Enter rings up the first match, which lets a cashier work
 * from the keyboard alone (and makes a keyboard-wedge scanner usable).
 */
const SearchBar = ({ value, onChange, onSubmit, inputRef, resultCount }) => {
  const { t } = useI18n();

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
      className="relative"
    >
      <span className="absolute start-4 top-1/2 -translate-y-1/2 text-slate-500 text-lg pointer-events-none">
        🔍
      </span>
      <input
        ref={inputRef}
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={t("pos.search.placeholder")}
        autoComplete="off"
        className="w-full h-12 ps-12 pe-24 rounded-2xl bg-slate-900 border border-slate-700 text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all"
      />
      {value && (
        <div className="absolute end-2 top-1/2 -translate-y-1/2 flex items-center gap-1">
          <span className="text-xs text-slate-400 tabular-nums">{resultCount}</span>
          <button
            type="button"
            onClick={() => onChange("")}
            aria-label={t("pos.search.clear")}
            className="w-9 h-9 rounded-xl bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white transition-colors"
          >
            ✕
          </button>
        </div>
      )}
    </form>
  );
};

export default SearchBar;
